import {render} from 'preact'
import {useUIHistoric} from "./useUIHistoric.ts";
import {ValueToday} from "./valueToday.tsx";
import {FutureTable} from "./futureTable.tsx";
import {GetForDate} from "./getForDate.tsx";
import {CompoundInterest} from "./compoundInterest.tsx";
import {setupColorScheme} from "./setupColorScheme.ts";
import {Collapse} from "bootstrap";

(Collapse);

import './scss/styles.scss'

setupColorScheme();

export function App() {
    const historic = useUIHistoric();

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active" aria-current="page">
                                Unidad Indexada.uy
                            </li>
                        </ol>
                    </nav>
                    <button className="navbar-toggler" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse"
                         id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link"
                                   aria-current="page"
                                   href="./inmobiliaria.html">Negocios Inmobiliarios</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active"
                                   aria-current="page"
                                   href="#fecha">Valor de la fecha</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link"
                                   href="#historica">Tabla
                                    histórica</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link"
                                   href="#datepick">Valor en fecha
                                    específica</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link"
                                   href="#compound">Calcular interés
                                    compuesto</a>
                            </li>
                        </ul>
                    </div>
                    {/*<div className="d-flex" role="search">*/}
                    {/*    <button className="btn btn-outline-success"*/}
                    {/*            onClick={toggleAds}*/}
                    {/*            type="button">&lt;&lt;&lt;*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
            </nav>
            <div class="container">
                <div className="row">
                    <div
                        // className={"col " + (showingAds ? "col-sm-8 col-12" : "col-12")}>
                        className={"col col-12"}>
                        <div className="container-fluid">
                            <div className="row gx-2">
                                <ValueToday
                                    historic={historic}></ValueToday>
                            </div>
                            <div className="row gx-2">
                                <FutureTable
                                    historic={historic}></FutureTable>
                                <GetForDate
                                    historic={historic}></GetForDate>
                                <CompoundInterest
                                    historic={historic}></CompoundInterest>
                            </div>
                        </div>
                    </div>
                    {/*<div*/}
                    {/*    className={"col " + (showingAds ? "col-sm-4 col-12" : "col-1 d-none") + " bg-secondary-subtle border-col"}>*/}
                    {/*    <div className="container-fluid p-5">*/}
                    {/*        <div className="card mt-2 ms-auto me-auto"*/}
                    {/*             style="width: 18rem;">*/}
                    {/*            <div className="card-body">*/}
                    {/*                <h5 className="card-title">Card*/}
                    {/*                    title</h5>*/}
                    {/*                <p className="card-text">Some*/}
                    {/*                    quick*/}
                    {/*                    example*/}
                    {/*                    text to build on the card*/}
                    {/*                    title*/}
                    {/*                    and*/}
                    {/*                    make*/}
                    {/*                    up the bulk of the card’s*/}
                    {/*                    content.</p>*/}
                    {/*                <a href="#"*/}
                    {/*                   className="btn btn-primary">Go*/}
                    {/*                    somewhere</a>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}

                    {/*        <div className="card mt-2 ms-auto me-auto"*/}
                    {/*             style="width: 18rem;">*/}
                    {/*            <div className="card-body">*/}
                    {/*                <h5 className="card-title">Card*/}
                    {/*                    title</h5>*/}
                    {/*                <p className="card-text">Some*/}
                    {/*                    quick*/}
                    {/*                    example*/}
                    {/*                    text to build on the card*/}
                    {/*                    title*/}
                    {/*                    and*/}
                    {/*                    make*/}
                    {/*                    up the bulk of the card’s*/}
                    {/*                    content.</p>*/}
                    {/*                <a href="#"*/}
                    {/*                   className="btn btn-primary">Go*/}
                    {/*                    somewhere</a>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}

                    {/*        <div className="card mt-2 ms-auto me-auto"*/}
                    {/*             style="width: 18rem;">*/}
                    {/*            <div className="card-body">*/}
                    {/*                <h5 className="card-title">Card*/}
                    {/*                    title</h5>*/}
                    {/*                <p className="card-text">Some*/}
                    {/*                    quick*/}
                    {/*                    example*/}
                    {/*                    text to build on the card*/}
                    {/*                    title*/}
                    {/*                    and*/}
                    {/*                    make*/}
                    {/*                    up the bulk of the card’s*/}
                    {/*                    content.</p>*/}
                    {/*                <a href="#"*/}
                    {/*                   className="btn btn-primary">Go*/}
                    {/*                    somewhere</a>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </>
    )
}

render(<App />, document.getElementById('app')!)
